module.exports = __webpack_public_path__ + "img/xiaohao.899d64f7.png";